import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    gridItem: {
      padding : '0 10px'
    },
    grid: {
      '&:before,&:after':{
        display: 'table',
        content: '" "',
      },
      '&:after':{
        clear: 'both',
      }
    },
    root: {
      backgroundColor: theme.palette.background.light,
      margin:20,
      display:"flex",
      justifyContent:"space-between",
    },
    tabs:{
      borderRadius: 5,
      backgroundColor: 'rgb(229, 239, 250)',
      minHeight: 30
    },
    tab: {
      minHeight: 30
    },
    containerConfirm: {
      borderRadius: 5,
      display: 'flex',
      flexDirection: 'column',
      padding:15,
      backgroundColor: 'rgb(238, 238, 238)',
      width:'100%',
      minWidth:'100%',
      maxWidth:'100%',
      '& > div':{
        paddingTop: theme.spacing(1),
        '& > p': {
          fontSize: 16, 
          fontWeight: 'bold'
        },
        '& > h6': {
          fontSize: 12
        }
      }
    },
    list:{
      maxHeight: '100%',
      overflow: 'auto'
    },
    listItem:{
      display: 'flex',
      justifyContent: 'space-between',
      '& > p': {
        fontSize: 11, 
      },
    },
    paper: {
      borderRadius:3,
      alignItems: 'left',
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(1),
      backgroundColor: theme.palette.primary.light,
      width: '100%',
      height: 200,
      '& > p': {
        fontSize: 16, 
        fontWeight: 'bold', 
        textAlign:'left',
        paddingBottom: theme.spacing(1),
      },
    },
    total:{
      display: 'grid',
      alignItems:'left',
      borderTop: '1px',
      borderTopColor: theme.palette.background.light,
      borderTopStyle: 'solid',
      '& > p': {
        fontSize: 16, 
        fontWeight: 'bold'
      }
    },
    inconsPago:{
        display:"flex",
        flex:'column',
        justifyContent:'space-around',
        borderBottom:'0px'
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    svg: {
      width: '100px',
      height: '100px',
      margin: '20px',
      display:'inline-block'
    },
    modalPaper: {
      position: 'absolute',
      width: 500,
      backgroundColor: theme.palette.primary.light,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    typography:{
      padding:5,
      fontSize: 18, 
      fontWeight: 'bold'  , 
      color: theme.palette.primary.main,
    },
    typographyBold:{
      fontWeight: 'bold'
    },
    totalConfirm:{
      display: 'flex',
      justifyContent: 'space-around',
      alignItems:'center',
      backgroundColor: theme.palette.primary.light,
      '& > p': {
        margin:theme.spacing(1),
        fontSize: 16, 
        fontWeight: 'bold'  , 
        color: theme.palette.primary.dark,
      }
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    modalDetailPaper: {
      position: 'absolute',
      width: 700,
      backgroundColor: theme.palette.primary.light,
      border: '1px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(1),
      borderRadius: 10
    },
    modalHeader:{
      display:'flex',
      justifyContent:'space-between',
      alignItems:'center'
    },
    modalBaner1:{
      backgroundColor: theme.palette.secondary.light,
      padding:10
    },
    modalBaner2:{
      display:'flex', 
      justifyContent:'space-around',
      alignItems:'baseline',
      margin: 10
    },
    modalBaner2Sub1:{
      display:'flex', 
    },
    modalBaner3:{
      display:'flex',
      flexDirection:'column',
      padding:10
    },
    modalBaner4:{
      display:'flex',
      justifyContent:'space-around',
      alignItems:'baseline',
      borderColor: theme.palette.primary.main,
      borderStyle: 'solid',
      borderWidth:'1px'
    },
    modalBaner4Sub1:{
      borderLeft: '1px',
      borderLeftColor: theme.palette.primary.main,
      borderLeftStyle: 'solid',
      padding:15
    },
    modalTypographyTittle:{
      fontSize:12, 
      textAlign:'left',
      marginRight:'5px'
    },
    modalTypographyField:{
      fontSize:12, 
      textAlign:'left',
      fontWeight:'700',
      marginRight:'5px'
    },
    form: {
      width: '100%',
      marginTop: theme.spacing(1),
    },
}));

export default useStyles;